import React from "react";
import "./cta.css";

const Cta = () => (
  <div className="ai__cta">
    <div className="ai__cta-content">
      <p>
        Unlock the future of possibilities with NexusAI's innovative solutions.
      </p>
      <h3>Elevate Your Potential with Intelligent Technologies.</h3>
    </div>
    <div className="ai__cta-btn">
      <button type="button">Get Started</button>
    </div>
  </div>
);

export default Cta;
